export const mergeAppendedConversationTimeline = (previous, fetched) => {
  const seen = new Set(previous.map(entry => entry?.timelineRowKey))
  const added = []
  for (let i = 0; i < fetched.length; i++) {
    const row = fetched[i]
    if (seen.has(row?.timelineRowKey)) continue
    seen.add(row?.timelineRowKey)
    added.push(row)
  }
  return [...previous, ...added]
}
